document.addEventListener('change', event => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
  const field = input.closest('variant-selects [data-option-name]');
  if (!field || !field.closest('variant-selects')) return;
  if (input instanceof HTMLInputElement && (input.type !== 'radio' || !input.checked)) return;
  const selectedValue = field.querySelector('[data-variant-selected-value]');
  if (selectedValue) selectedValue.textContent = input.value;
});

if (!customElements.get('product-specification-scroll')) {
  class ProductSpecificationScroll extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.product-specifications__scroll');
      this.indicator = this.querySelector('.product-specifications__scroll-indicator');
      this.thumb = this.indicator?.firstElementChild;
      if (!this.scroller || !this.thumb || this.onScroll) return;
      this.onResize = () => this.updateIndicator();
      this.onScroll = () => {
        const position = this.scroller.scrollLeft;
        if (position === this.lastPosition) return;
        this.updateIndicator();
        if (this.indicator.hidden) return;
        this.classList.add('is-scrolling');
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => this.classList.remove('is-scrolling'), 800);
      };
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.scroller);
        const table = this.scroller.querySelector('table');
        if (table) this.resizeObserver.observe(table);
      } else {
        window.addEventListener('resize', this.onResize, { passive: true });
      }
      this.updateIndicator();
    }

    updateIndicator() {
      const visible = this.scroller.clientWidth;
      const total = this.scroller.scrollWidth;
      const maximum = total - visible;
      this.lastPosition = this.scroller.scrollLeft;
      this.indicator.hidden = visible <= 0 || maximum <= 1;
      if (this.indicator.hidden) {
        this.classList.remove('is-scrolling');
        clearTimeout(this.hideTimer);
        return;
      }
      const width = Math.min(visible, Math.max(28, visible * visible / total));
      const rtl = getComputedStyle(this.scroller).direction === 'rtl';
      const position = Math.max(0, Math.min(maximum, rtl ? maximum + this.lastPosition : this.lastPosition));
      this.thumb.style.width = `${width}px`;
      this.thumb.style.transform = `translateX(${position / maximum * (visible - width)}px)`;
    }

    disconnectedCallback() {
      clearTimeout(this.hideTimer);
      this.resizeObserver?.disconnect();
      if (this.onScroll) this.scroller?.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      this.onScroll = null;
      this.classList.remove('is-scrolling');
    }
  }
  customElements.define('product-specification-scroll', ProductSpecificationScroll);
}
